import React, { useEffect, useMemo, useState } from 'react';

export const useIsInViewport = (ref: React.RefObject<HTMLElement | null>, enable: boolean) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      typeof window === 'object'
        ? new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting))
        : undefined,
    [],
  );

  useEffect(() => {
    if (ref.current && enable) {
      observer?.observe(ref.current);
    }

    return () => {
      observer?.disconnect();
    };
  }, [ref, observer, enable]);

  return isIntersecting;
};
